import {
  Modal,
  Form,
  Tag
} from "antd";
import React, {
  forwardRef,
  useEffect,
  useState,
  useRef,
} from "react";
import http from "@/utils/http";
import api from "@/utils/api";
import commonFn from "@/utils/commonFn";
import { CustomTable, CustomTableExtend, FileDetail } from "@/hocComponents";

const MainTable = forwardRef((props, ref) => {
  const initTableHead = {
    name: undefined,
    hireDateStr: undefined,
    phone: undefined,
    workOrderCount: undefined,
    addressCity: undefined,
    fedId: undefined,
    status: undefined,
  }
  const [tableHead, setTableHead] = useState(initTableHead);

  const [checkModalFlag, setCheckModalFlag] = useState(false);
  const [checkFileList, setCheckFileList] = useState([]);

  const tableFilterFn = (event, key, type = 'Input') => {
    commonFn.tableFilterFn({event, key, type, setTableHead, getTableListFn})
  }

  const initColumns = [
    // {
    //   dataIndex: '#'
    // },
    {
      title: "Vendor Name",
      dataIndex: "name",
      titleType: "Input",
      width: 160,
      isSorter: true,
      sortterMultiple: 3,
      onChange: (e) => tableFilterFn(e, "name"),
    },
    {
      title: 'Hire Date',
      dataIndex: "hireDate",
      titleType: 'DatePicker',
      isSorter: false,
      format: 'MM/DD/YYYY',
      onChange: (e) => tableFilterFn(e, 'hireDateStr', 'DatePicker'),
      render: (text) => {
        return text
      }
      // onChange: (e) => tableFilterFn(e, 'hireDate', 'DatePickerFormat'),
    },
    {
      title: 'Phone #',
      dataIndex: "phone",
      titleType: 'Input',
      isSorter: true,
      sortterMultiple: 3,
      onChange: e => tableFilterFn(e, 'phone'),
    },
    {
      title: 'Job Requests',
      dataIndex: "workOrderCount",
      titleType: '',
      isSorter: true,
      sortterMultiple: 3,
      // onChange: e => tableFilterFn(e, 'workOrderCount'),
      render: (text, record) => {
        // if (text == 0 ) return text;
        return (
          <span
            onClick={() => window.open(`${window.location.origin}#/AccountPayable/GardenerAPMaintenance?vendorId=${record.vendorId}`, "_blank", "noopener,noreferrer")}
            style={{
              color: "#1890ff",
              cursor: "pointer",
            }}
          >
            {text}
          </span>
        );
      },
    },
    {
      title: 'Vendor Address',
      dataIndex: "addressCity",
      titleType: 'Input',
      isSorter: true,
      sortterMultiple: 3,
      width:260,
      onChange: e => tableFilterFn(e, 'mailingAddressCity'),
    },
    {
      title: 'Tax ID',
      dataIndex: "fedId",
      titleType: 'Input',
      isSorter: true,
      sortterMultiple: 3,
      onChange: e => tableFilterFn(e, 'fedId'),
    },
    {
      title: 'Status',
      dataIndex: "status",
      titleType: 'Select',
      sortterMultiple: 3,
      selectOptions: [
        {value: 'A', label: 'Active'},
        {value: 'I', label: 'Inactive'},
      ],
      onChange: (e) => tableFilterFn(e, "status", 'Select'),
      render: (text) => {
        const isEnabled = text == "A";
        return (
          <Tag
            color={isEnabled ? "green" : "red"}
          >
            { isEnabled ? "Active" : "Inactive" }
          </Tag>
        )
      },
    },
  ]

  const [columns, setColumns] = useState(initColumns);
  const [refreshKey, setRefreshKey] = useState(0);
  const [tableList, setTableList] = useState([]);
  const [tableLoading, setTableLoading] = useState(false);
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 25,
    total: 0,
  });

  //列表
  const getTableListFn = async (current, pageSize, tableHead = {}) => {
    setTableLoading(true);
    const params = {
      page: current || pagination.current,
      count: pageSize || pagination.pageSize,
      ...tableHead,
    };
    const response = await http.get(api.gardenerAPList, {params});
    if(!response) return
    if(response && response?.code !== "1") {
      commonFn.modalFailedFn(response)
      setTableLoading(false);
      return
    }
    const list = (response.data.list || []).map((item, index) => ({ ...item, '#': (params.page - 1) * params.count + index + 1}));
    setTableList(list);
    setPagination((prev) => ({
      ...prev,
      total: response.data.total || 0,
      current: params.page,
      pageSize: params.count,
    }));
    setTableLoading(false);
  };

  const handleTableChange = (pagination, filters, sorter) => {
    getTableListFn(pagination.current, pagination.pageSize, tableHead);
  };

  const initColunmsFn = () => {
    setPagination({
      current: 1,
      pageSize: 25,
      total: 0,
    })
    setTableList([])
    setTableHead(initTableHead);
    setColumns(initColumns);
  }

  useEffect(() => {
    initColunmsFn()
    getTableListFn(1, 25)
  }, [refreshKey])

  return (
    <div>
      <CustomTableExtend
        columns={columns}
        setColumns={setColumns}
        initColumns={initColumns}
        refreshKey={refreshKey}
        setRefreshKey={setRefreshKey}
        noShowList={[!commonFn.btnAuthorityFlag('Download') && 'download']}
      >
      </CustomTableExtend>

      <CustomTable 
        refreshKey={refreshKey}
        tableLoading={tableLoading}
        rowSelection={false}
        rowKey="id"
        columns={columns}
        tableList={tableList}
        pagination={pagination}
        handleTableChange={handleTableChange}
      />

    </div>
  );
});
export default MainTable;